import { render, staticRenderFns } from "./BillTabDetails.vue?vue&type=template&id=5d407b6f&scoped=true&"
import script from "./BillTabDetails.vue?vue&type=script&lang=ts&"
export * from "./BillTabDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d407b6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
